<template>
	<div class="container">
		<div class="top-wrapper">
			<img class="top-img"
				:src="topImg" />
			<div class="name-box">
				<div class="name-sub">Home</div>
				<div class="name-ch">首页</div>
			</div>
		</div>
		<div class="brand-section">
			<div class="section-title">
				品牌理念
			</div>
			<img class="brand-img"
				:src="brandImg" />
			<div class="brand-title">专注营养，连结全球</div>
			<div class="brand-title-sub">OPULRICH PTE. LTD.
				是新加坡专业营养补充品贸易商，致力于将优质产品带向世界。</div>
		</div>
		<page-footer></page-footer>
	</div>
</template>

<script>
	import pageFooter from "@/components/common/page-footer/page-footer.vue"
	export default {
		name: 'home',
		components: {
			pageFooter
		},
		data() {
			return {
				topImg: require('@/assets/home1.png'),
				brandImg: require('@/assets/home2.png')
			}
		}
	}
</script>

<style lang="scss"
	scoped>
	.container {
		text-align: left;
	}

	.top-wrapper {
		position: relative;

		.top-img {
			width: 100%;
			height: 1080px;
		}

		.name-box {
			position: absolute;
			top: 30%;
			transform: translateY(-50%);
			left: 10%;
			color: #fff;
			text-align: left;

			.name-sub {
				position: relative;
				font-size: 12px;
				text-align: left;
				padding: 0 16px;

				&::before {
					position: absolute;
					content: "";
					height: 1px;
					width: 15px;
					top: 50%;
					transform: translateY(-50%);
					left: -2px;
					background: #fff;
				}

				&::after {
					position: absolute;
					content: "";
					height: 1px;
					width: 15px;
					top: 50%;
					transform: translateY(-50%);
					right: -2px;
					background: #fff;
				}
			}

			.name-ch {
				margin-top: 10px;
				font-weight: bold;
				font-size: 26px;
			}
		}


	}

	.brand-section {
		width: 60%;
		margin: auto;
		margin-top: 30px;
		color: #333;

		.brand-img {
			width: 100%;
			height: 300px;
			margin-top: 30px;
		}

		.brand-title {
			font-weight: bold;
			font-size: 18px;
			margin-top: 20px;
		}

		.brand-title-sub {
			font-size: 12px;
			margin-top: 13px;
		}
	}

	.section-title {
		font-size: 28px;
		font-weight: bold;
		color: #333;
		position: relative;

		&:before {
			position: absolute;
			content: "";
			left: 0;
			width: 50px;
			height: 4px;
			background-color: #3E8CEF;
			bottom: -10px;
		}
	}
</style>